import React from "react";
import { Tooltip } from "./Tooltip";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              Copyright © 2024{" "}
              <a className="fw-600" href="/">
                Travon Speller
              </a>
              . All Rights Reserved.
            </p>
          </div>
          <div className="col-lg-6 wow fadeInUp">
            <p className="mb-0 text-center text-lg-end">
              <div className="col-auto col-lg-2 d-flex justify-content-end ps-0">
                <ul className="social-icons">
                  <li className="social-icons-linkedin">
                    <Tooltip text="LinkedIn" placement="bottom">
                      <a
                        href="https://www.linkedin.com/in/travon-speller/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin-square" />
                      </a>
                    </Tooltip>
                  </li>
                  <li className="social-icons-twitter">
                    <Tooltip text="Twitter" placement="bottom">
                      <a
                        href="https://twitter.com/travon3000"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-twitter" />
                      </a>
                    </Tooltip>
                  </li>
                  <li className="social-icons-instagram">
                    <Tooltip text="Instagram" placement="bottom">
                      <a
                        href="https://www.instagram.com/kicksfor_tray/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-instagram" />
                      </a>
                    </Tooltip>
                  </li>
                </ul>
              </div>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
